/* unplugin-vue-components disabled */
export default {
  mixins: [ModelValue(Number)],
}
